import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './animated-hover-link-button.scss';

export function AnimatedHoverLinkButton({
  linkUrl,
  linkText = 'Learn More',
  wrapperClass = null,
  wrapperStyle = null,
  isPreHovered = false,
  buttonTextColor = 'text-cool-gray-30',
  target = null,
  rel = null,
  dataTrackingId = null,
  dataTrackingValue = null,
  adUnit = null,
}) {
  return (
    <div
      className={classNames('cta-core-link size-16 pos-r', wrapperClass, {
        'is-pre-hovered': isPreHovered,
      })}
      style={wrapperStyle}
    >
      <a
        className="learn-more pos-r d-inline-block p-0 overflow-hidden"
        href={linkUrl}
        target={target}
        rel={rel}
        data-tracking-id={dataTrackingId}
        data-tracking-value={dataTrackingValue}
      >
        <span className="circle text-cool-gray-10 d-block m-0 pos-r bg-blue-50">
          <i className="icon arrow pos-a top-0 bottom-0 m-auto" aria-hidden />
        </span>
        <span className={classNames('button-text fw-normal pos-r text-center', buttonTextColor)}>{linkText}</span>
      </a>
      {adUnit && (
        <div className="pos-a top-0 left-0" style={{ width: '1px', height: '1px' }}>
          {adUnit}
        </div>
      )}
    </div>
  );
}

AnimatedHoverLinkButton.propTypes = {
  linkUrl: PropTypes.string.isRequired,
  linkText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  wrapperClass: PropTypes.string,
  wrapperStyle: PropTypes.shape({}),
  isPreHovered: PropTypes.bool,
  buttonTextColor: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string,
  dataTrackingId: PropTypes.string,
  dataTrackingValue: PropTypes.string,
  adUnit: PropTypes.node,
};
